<template>
  <div class="controller-service">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item
          class="mb-5"
          label="Tên dịch vụ"
          :colon="false"
          prop="name"
        >
          <a-input v-model="form.name" placeholder="Tên" />
        </a-form-model-item>
        <a-form-model-item
          class="mb-5"
          label="Mô tả"
          :colon="false"
          prop="description"
        >
          <a-textarea
            :rows="4"
            v-model="form.description"
            placeholder="Mô tả"
          />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="currentAvatar || avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import ENDPOINT from '@/config/endpoint'
import { upload } from '@/services/landing-page/storage'
import { createTechnology, updateTechnology, fetchTechnologyById } from '@/services/landing-page/home/technology'
  export default {
    name: 'ControllerService',
    data() {
      return {
        callingAPI: false,

        form: {
          name: '',
          description: '',
          photo_url: '',
          active: 1,
        },
        rules: {
          name: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
          description: [
            { required: true, message: 'Giá trị không được để trống.', trigger: ['blur', 'change'] },
          ],
        },

        currentAvatar: null,
        avatarUrl: "",
      }
    },
    async beforeMount() {
      if (this.$route.params.id) {
        await this.loadData()
      }
    },
    methods: {
      async loadData() {
        try {
          const response = await fetchTechnologyById(this.$route.params.id)
          this.form.name = response.data.name
          this.form.description = response.data.description
          this.form.photo_url = response.data.photo_url
          this.form.active = response.data.active

          this.avatarUrl = `${ENDPOINT.BACKEND_URL}${response.data.photo_url}`
        } catch (error) {
          
        }
      },
       onAvatarChange(e) {
        if (e.target.files.length) {
          const file = e.target.files[0];
          this.currentAvatar = file;
          this.avatarUrl = URL.createObjectURL(file);
        }
      },
      async handleUploadAvatar() {
        try {
          const formData = new FormData()
          formData.append('type', 'ckeditor')
          formData.append('upload', this.currentAvatar)
          formData.append("position_type", "1");

          const response = await upload(formData)
          this.form.photo_url = response.data[0].path;
        } catch (error) {}
      },
      handleSubmit(e) {
        e.preventDefault();
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.callingAPI = true
              if (this.currentAvatar) {
                await this.handleUploadAvatar();
              }

              const data = {
                name: this.form.name,
                description: this.form.description,
                photo_url: this.form.photo_url,
                active: 1
              }

              let response = null;
              if (this.$route.params.id) {
                 response = await updateTechnology(this.$route.params.id, data)
              } else {
                 response = await createTechnology(data)
              }
              if (response.status == 1) {
                const message = this.$route.params.id
                  ? "Cập nhật thành công."
                  : "Thêm mới thành công.";
                this.$notification.success({
                  message: "Thành công",
                  description: message,
                });
                this.$router.push({ name: "Technology" });
              } else {
                this.$notification.error({
                  message: "Thất bại",
                  description: response.errors[0],
                });
              }
            } catch (error) {
              this.callingAPI = false
              console.log(error);
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>